import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

import { cn } from "@/shared/utils";

function Label(props: React.ComponentProps<typeof LabelPrimitive.Root> & { optional?: boolean; readOnly?: boolean }) {
    const { className, children, optional = false, readOnly = false, asChild, ...rest } = props;
    return (
        <LabelPrimitive.Root
            data-slot="label"
            className={cn(
                "text-content-emphasis text-s flex items-center gap-2 font-bold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
                className
            )}
            {...rest}
        >
            {asChild ? (
                children
            ) : (
                <>
                    {children} {optional && !readOnly && <span className="font-normal">Optioneel</span>}
                </>
            )}
        </LabelPrimitive.Root>
    );
}

function DtLabel(props: React.ComponentProps<typeof LabelPrimitive.Root>) {
    const { className, ...rest } = props;
    return (
        <LabelPrimitive.Root
            data-slot="label"
            asChild
            className={cn(
                "text-content-subtle text-s flex items-center gap-2 font-bold select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
                className
            )}
        >
            <dt {...rest} />
        </LabelPrimitive.Root>
    );
}

export { DtLabel, Label };
